import { NavigateFunction } from "react-router-dom";

export const navigateToHome = ({
  navigate,
  search,
  replace = false,
}: {
  navigate: NavigateFunction;
  search: string;
  replace?: boolean;
}): void => {
  navigate(
    {
      pathname: "/home",
      search,
    },
    { replace },
  );
};
